import { render } from "./campaignSummaryCard.vue?vue&type=template&id=33c736ce&scoped=true"
import script from "./campaignSummaryCard.vue?vue&type=script&lang=js"
export * from "./campaignSummaryCard.vue?vue&type=script&lang=js"

import "./campaignSummaryCard.vue?vue&type=style&index=0&id=33c736ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c736ce"]])

export default __exports__